module.exports = __webpack_public_path__ + "static/img/red-suspension-bridge-3493772.00e86a9d.jpg";